import React from 'react'

const Nodejs_Coding_Pratice_9 = () => {
  return (
    <div>
      <h1>Coding Pratice 9</h1>
    </div>
  )
}

export default Nodejs_Coding_Pratice_9
